import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';

class Piaohong extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        columnId: PropTypes.string,
    };

    constructor(...argu) {
        super(...argu);

        const { content, columnId } = this.props;
        const list = content.columnId || [];

        // columnId
        this.state = {
            piaohong: content.piaohong && list.includes(columnId),
        };
    }
    componentDidMount() {
        const { piaohong } = this.state;
        const { image } = this.props.content;

        if (piaohong) {
            const body = document.getElementsByTagName('body')[0];

            body.className += ' yuandan';
            body.style.backgroundImage = `url('${image}')`;
        }
    }
    // 关闭飘红
    handleClosePiaohongClick = event => {
        event.stopPropagation();

        this.setState(
            {
                piaohong: false,
            },
            () => {
                const body = document.getElementsByTagName('body')[0];

                body.className = body.className.replace('yuandan', '');
                body.style.backgroundImage = null;
            },
        );
    };
    render() {
        const { piaohong } = this.state;
        const { url } = this.props.content;

        return piaohong ? (
            <div className={styles.piaohong}>
                <a className={styles.piaohonglink} href={url} target="_blank" rel={relText} />
                <input className={styles.close} type="button" onClick={this.handleClosePiaohongClick} />
            </div>
        ) : null;
    }
}

export default Piaohong;
